import Image from "next/image";
import { ReactSVG } from 'react-svg'
import Link from "next/link";
import store from "store2";
import { KTGet } from "@/kyna/lib/db";
import { useQuery } from "react-query";
import DashAppLogo from "../../../public/assets/img/dash-app-logo.svg";
import AppLogo from '../../../public/assets/img/app-logo.png';
import ArrowLongLeft from '../../../public/icons/arrow-long-left.svg';
import BookingForm from "./booking/BookingForm";
const BookingPage = () => {
  const transaction_no = store.get("transaction_no");
  const { data, status, loading } = useQuery("booking", () => {
    KTGet(`/api/booking/public`, {
      where: `transaction_no='${transaction_no}'`,
    });
  });
  return (
    <>
      <section className="mx-auto">
        <div className="relative">

          <div className="relative md:fixed w-full md:w-5/12 h-full md:min-h-screen inset-0">
            <div className="bg-blue-500 h-full md:h-screen py-12 md:py-20 px-6 sm:px-14 md:px-10 lg:px-16 xl:px-20">
              <Link href="/">
                <a className='app-logo block w-full rounded-full max-w-[80px] md:max-w-[120px] h-[80px] md:h-[120px] bg-white p-2 md:p-3'><Image src={AppLogo} alt="AppLogo" /></a>
              </Link>
              <div className="mt-8 md:mt-14">
                <h2>We hope all is well!</h2>
                <p className="text-white text-lg md:text-xl lg:text-2xl leading-snug lg:leading-normal">
                  We are at the forefront of mental health advocacy for <strong>{new Date().getFullYear() - new Date("January 15, 1950").getFullYear()} years now</strong>, reaching out and changing millions of lives.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full md:w-7/12 ml-auto">
            <div className="pt-8 pb-20 px-6 sm:px-14 lg:px-16 max-w-4xl mx-auto">
              <div className="flex items-center justify-end flex-wrap gap-3 mb-10">
                <div className="form-group !mb-0">
                  <Link href="/">
                    <a className="btn btn-light-gray">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-4 mr-2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                      </svg>
                      Back to home
                    </a>
                  </Link>
                </div>
                <div className="form-group !mb-0">
                  <Link href="/account/login/">
                    <a className="btn btn-primary">
                      Login
                    </a>
                  </Link>
                </div>
              </div>
              
              <h2 className="text-blue text-4xl sm:text-5xl leading-none">Book an appointment</h2>
              
              <p className="text-gray-600 text-lg md:text-xl lg:text-2xl leading-snug">
                We will continue to enhance individual and collective well-being for a mentally healthy Philippines!
              </p>

              <div className="mt-10"></div>

              <ul
                className="nav nav-tabs flex flex-row flex-wrap list-none border-b-0 pl-0"
                id="tabs-tab"
                role="tablist"
              >
                <Link passhref href="/booking">
                  <li className="nav-item cursor-pointer" role="presentation">
                    <span
                      className="
                        nav-link
                        block
                        font-medium
                        leading-tight
                        text-gray-400
                        border-b-2 border-blue
                        mr-8 sm:mr-14
                        hover:text-blue
                        focus:border-transparent
                        hover:border-b-blue hover:border-b-2
                        pb-4
                        "
                      id="tabs-booking-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#tabs-booking"
                      role="tab"
                      aria-controls="tabs-booking"
                      aria-selected="false"
                    >
                      Booking
                    </span>
                  </li>
                </Link>
                <Link
                  passhref
                  href={
                    data?.data?.result?.bookingFor ? "/booking/patient" : ""
                  }
                >
                  <li className="nav-item cursor-pointer" role="presentation">
                    <span
                      className={`
                        ${
                          data?.data?.result?.bookingFor
                            ? "hover:text-blue hover:border-b-blue hover:border-b-2"
                            : "cursor-not-allowed"
                        }
                        nav-link
                        block
                        font-medium
                        leading-tight
                        text-gray-400
                        border-b-2 border-transparent
                        mr-8 sm:mr-14
                        focus:border-transparent
                        pb-4
                        `}
                      id="tabs-patient-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#tabs-patient"
                      role="tab"
                      aria-controls="tabs-patient"
                      aria-selected="true"
                    >
                      Clients / Service Users
                    </span>
                  </li>
                </Link>
                <li className="nav-item" role="presentation">
                  <span
                    className={`
                      ${
                        data?.data?.result?.bookingFor
                          ? "hover:text-blue hover:border-b-blue hover:border-b-2 cursor-pointer"
                          : "cursor-not-allowed"
                      }
                        nav-link
                        block
                        font-medium
                        leading-tight
                        text-gray-400
                        border-x-0 border-t-0 border-b-2 border-transparent
                        focus:border-transparent
                        pb-4
                        `}
                    id="tabs-account-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#tabs-account"
                    role="tab"
                    aria-controls="tabs-account"
                    aria-selected="false"
                  >
                    Account
                  </span>
                </li>
              </ul>
              <div className="border-b border-gray-200 mb-10" />

              <div className="tab-content" id="tabs-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="tabs-booking"
                  role="tabpanel"
                  aria-labelledby="tabs-booking-tab"
                >
                 <BookingForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookingPage;
